import React from "react";
import { useHistory } from "react-router";
import VerifyDoctors from "../Components/Admin/VerifyDoctors";
import MakeAdmin from "../Components/Admin/MakeAdmin";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    maxWidth: "100vw",
  },
  body: {
    //display: "flex",
    //alignItems: "center",
    //justifyContent: "center",
    padding: theme.spacing(6, 4),
    //height: "inherit",
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
    height: 240,
    borderTop: `6px solid ${theme.palette.info.main}`,
  },
  paperAdmin: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
    height: 240,
    borderTop: `6px solid ${theme.palette.primary.dark}`,
  },
  paperTable: {
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
    width: "auto",
    height: "auto",
    minWidth: 726,
    minHeight: 322,
    borderTop: `6px solid ${theme.palette.warning.light}`,
  },
}));

const Admin = ({ match }) => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.root}>
      <Container className={classes.body}>
        <Grid
          container
          direction="row"
          justify="space-evenly"
          alignItems="center"
          spacing={6}
        >
          <Grid item xs={12} lg={4}>
            <Paper className={classes.paper}>Feature Request</Paper>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Paper className={classes.paper}>Feature Request</Paper>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Paper className={classes.paperAdmin}>
              <MakeAdmin />
            </Paper>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Paper className={classes.paperTable}>
              <VerifyDoctors />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Admin;
